export enum CandidatesTab {
  All = "All",
  Valid = "Valid",
  Expired = "Expired",
  OnGoing = "OnGoing",
}
